<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>

  <mat-dialog-content>

    <!-- File picker -->
    <div class="file-picker">
      <input
        #fileInput
        type="file"
        accept=".xlsx,.xls"
        class="hidden-input"
        (change)="onFileSelected($event)"
      />
      <button
        mat-stroked-button
        (click)="fileInput.click()"
        [disabled]="isLoading() || isImporting()"
      >
        <mat-icon>upload_file</mat-icon>
        {{ 'btn_select_file' | i18n }}
      </button>
      @if (selectedFile) {
        <span class="filename">{{ selectedFile.name }}</span>
      }
    </div>

    <!-- Loading spinner -->
    @if (isLoading()) {
      <div class="loading-row">
        <mat-spinner diameter="20"></mat-spinner>
        <span>{{ 'loading_label' | i18n }}</span>
      </div>
    }

    <!-- Results -->
    @if (matchResult && parseResults && !isLoading()) {

      <!-- Matched sheets -->
      @if (matchResult.matched.length) {
        <div class="section">
          <p class="section-label">{{ 'matched_sheets_title' | i18n }}</p>
          @for (entry of matchResult.matched; track entry.match.sheetName; let i = $index) {
            <div class="sheet-row">
              <mat-icon class="icon-ok">check_circle</mat-icon>
              <span class="sheet-name">{{ entry.match.sectionLabel }}</span>
              @if (importResults(); as results) {
                <span class="row-count">{{ results[i].created }} / {{ parseResults[i].validRowCount }} {{ 'rows_label' | i18n }}</span>
                @if (results[i].errors.length || results[i].sheetError) {
                  <span class="error-badge">
                    <mat-icon class="icon-error">error_outline</mat-icon>
                    {{ results[i].errors.length + (results[i].sheetError ? 1 : 0) }} {{ 'errors_label' | i18n }}
                  </span>
                }
              } @else {
                <span class="row-count">{{ parseResults[i].validRowCount }} {{ 'rows_label' | i18n }}</span>
                @if (parseResults[i].errors.length) {
                  <span class="error-badge">
                    <mat-icon class="icon-error">error_outline</mat-icon>
                    {{ parseResults[i].errors.length }} {{ 'errors_label' | i18n }}
                  </span>
                }
              }
            </div>
            @if (importResults(); as results) {
              @if (results[i].sheetError) {
                <div class="error-list">
                  <div class="error-row">{{ results[i].sheetError }}</div>
                </div>
              }
              @if (results[i].errors.length) {
                <div class="error-list">
                  @for (e of results[i].errors; track e.row) {
                    <div class="error-row">{{ e.message }}</div>
                  }
                </div>
              }
            } @else {
              @if (parseResults[i].errors.length) {
                <div class="error-list">
                  @for (e of parseResults[i].errors; track e.row) {
                    <div class="error-row">{{ 'row_label' | i18n }} {{ e.row }}: {{ e.message }}</div>
                  }
                </div>
              }
            }
          }
          <div class="total-row">
            @if (importResults()) {
              <strong>{{ totalImported }} / {{ totalValidRows }} {{ 'total_rows_imported_label' | i18n }}</strong>
            } @else {
              <strong>{{ totalValidRows }} {{ 'total_rows_label' | i18n }}</strong>
            }
          </div>
        </div>
      }

      <!-- Skipped sheets -->
      @if (matchResult.skipped.length) {
        <div class="section">
          <p class="section-label warn-label">
            <mat-icon>warning_amber</mat-icon>
            {{ 'skipped_sheets_title' | i18n }}
          </p>
          @for (name of matchResult.skipped; track name) {
            <div class="sheet-row skipped">
              <span class="sheet-name">{{ name }}</span>
              <span class="skip-hint">{{ 'skipped_hint' | i18n }}</span>
            </div>
          }
        </div>
      }

      <!-- Duplicate handling — hidden once import has run -->
      @if (!importResults()) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'duplicate_handling_label' | i18n }}</mat-label>
          <mat-select [(ngModel)]="duplicateHandling" [disabled]="isImporting()">
            @for (option of duplicateHandlingOptions; track option) {
              <mat-option [value]="option">
                {{ ('duplicate_handling_' + option) | i18n }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

    }

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (importResults()) {
      <button mat-flat-button color="primary" (click)="onDone()">
        {{ 'btn_done' | i18n }}
      </button>
    } @else {
      <button mat-button mat-dialog-close [disabled]="isImporting()">
        {{ 'btn_cancel' | i18n }}
      </button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!canImport"
        (click)="onImport()"
      >
        @if (isImporting()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          {{ 'btn_import' | i18n }}
        }
      </button>
    }
  </mat-dialog-actions>
</ng-container>
